import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';

@Pipe({
  name: 'custCurrency',
})
export class CustomAgileCurrency implements PipeTransform {
  constructor(public appInit: LegacyBookInitService) {}

  transform(value: any, currencyCode?: any, countryCode?: any): any {
    let newVal = +value;
    let rate = newVal.toLocaleString(countryCode, { style: 'currency', currency: currencyCode });
    let pathData = location.pathname.split('/');
    let appName = pathData[1];

    return appName === 'onecart' && this.appInit?.hideDecimalPointsFromRates ? (rate ? rate.split('.')[0] : rate) : rate;
  }
}

@Pipe({
  name: 'custShortHand',
})
export class CustomAgileShortHand implements PipeTransform {
  transform(value: number): string {
    if (value === null || value === undefined) return '0';

    if (value >= 1000000000) {
      return Math.floor((value / 1000000000) * 100) / 100 + 'B'; // Billions
    }
    if (value >= 1000000) {
      return Math.floor((value / 1000000) * 100) / 100 + 'M'; // Millions
    }
    if (value >= 1000) {
      return Math.floor((value / 1000) * 100) / 100 + 'K'; // Thousands
    }
    return (Math.floor(value * 100) / 100).toString(); // Return value as is if it's less than 1000
  }
}

@Pipe({
  name: 'custShortHandCurrency',
})
export class CustomAgileShortHandCurrency implements PipeTransform {
  constructor(private custShortHand: CustomAgileShortHand, private currencyPipe: CustomAgileCurrency, private decimalPipe: DecimalPipe) {}

  transform(value: number, currencyCode: string = 'USD', digitsInfo: string = '1.0-0'): string {
    let shortHandValue = this.custShortHand.transform(value);
    let convertedCurrency = this.currencyPipe.transform(value, currencyCode);
    let numValue = this.decimalPipe.transform(value, '1.2');
    return convertedCurrency.replace(numValue.toString(), shortHandValue);
  }
}
